import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/core/auth/auth.service';
import { AppState } from '@app/store/states/app.state';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export const isAuthenticated: CanActivateFn = () => {
  const authService = inject(AuthService);
  const appState = inject(AppState);
  const router = inject(Router);

  return authService.authenticated().pipe(
    map((value) => {
      appState.authenticated = value;
      if (!value) {
        router.navigate(['/login']).then();
        return false;
      }
      return value;
    }),
    catchError(() => {
      router.navigate(['/login']).then();
      return of(false);
    })
  );
};

export const canAuthenticate: CanActivateFn = () => {
  const authService = inject(AuthService);
  const appState = inject(AppState);
  const router = inject(Router);

  return authService.authenticated().pipe(
    map((value) => {
      appState.authenticated = value;
      if (value) {
        router.navigate(['/']).then();
        return false;
      }
      return true;
    })
  );
};

export const canEnterPassword: CanActivateFn = () => {
  const appState = inject(AppState);
  const router = inject(Router);

  if (!appState.accountEmail) {
    router.navigate(['/login']).then();
    return false;
  }
  return true;
};
